/* eslint-disable consistent-return */
/* eslint-disable no-mixed-operators */
import { HTTP_CODE, ERROR_HANDLING_EXPERIENCE } from '../../utils/redirector-utils';

const minStoreDetailsPathLength = 7;

const isStoreDetailsPath = (path) => /^\/l\//.test(path) && path.split('/').length >= minStoreDetailsPathLength;

const validStates = [
  'AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'DC', 'FL', 'GA', 'GU', 'HI', 'ID', 'IL', 'IN',
  'IA', 'KS', 'KY', 'LA', 'ME', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ',
  'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'PR', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT',
  'VA', 'VI', 'WA', 'WV', 'WI', 'WY'
];

const isValidStateCode = (code) => validStates.includes(code?.toUpperCase());
const isLPath = (path) => /^\/l\//.test(path);
const isStoreFinderPath = (path) => {
  if (!isLPath(path)) {
    return false;
  }
  if (path === '/l/') return true;

  const pathArray = path.split('/');
  // Check for invalid "/l/search" format
  const invalidSearchPath = /^\/l\/search\/$/; // Matches only "/l/search/"
  if (pathArray.length === 3 && pathArray[2] === 'search' || invalidSearchPath.test(path)) { // /l/search/ or /l/search
    return false;
  }
  if (/(^\b(?:search|storeDirectory)\b$)/.test(pathArray[2])) { // /l/search/131 or /l/storeDirectory/
    return true;
  }
  if (isValidStateCode(pathArray[2]) && /[A-Z]{2}$/.test(pathArray[2])) { // /l/CA
    return true;
  }
  if (isValidStateCode(pathArray[3]) && /[A-Z]{2}$/.test(pathArray[3])) { // /l/search/CA
    return true;
  }
};

export const isPathFormatSupported = (path) => isStoreDetailsPath(path);

export const isStoreIdValid = (storeId) => /^\d+$/.test(storeId) && (storeId?.length === 4 || storeId?.length === 3);

export const getStoreIdFromStoreDetailsPath = (path) => (isStoreDetailsPath(path) ? path.split('/')[6] : null);

export const invalidPathHandler = ({ path }) => {
  if (!isStoreFinderPath(path)) {
    return {
      shouldRedirect: false,
      isErrorStatus: true,
      httpCode: HTTP_CODE.NOT_FOUND,
      description: `Invalid path ${path}`,
      errorHandlingExperience: ERROR_HANDLING_EXPERIENCE.GENERIC
    };
  }
  return null;
};

export const invalidStoreIdHandler = ({ storeId }) => {
  if (!isStoreIdValid(storeId)) {
    return {
      shouldRedirect: false,
      isErrorStatus: true,
      httpCode: HTTP_CODE.NOT_FOUND,
      description: `Invalid Store ID ${storeId}`,
      errorHandlingExperience: ERROR_HANDLING_EXPERIENCE.GENERIC
    };
  }
  return null;
};

export const notFoundHandler = ({ data, storeId }) => {
  if (data && !data.storeSearch) {
    return {
      shouldRedirect: false,
      isErrorStatus: true,
      httpCode: HTTP_CODE.NOT_FOUND,
      description: `Store ID ${storeId} not found`,
      errorHandlingExperience: ERROR_HANDLING_EXPERIENCE.GENERIC
    };
  }

  return null;
};